/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamSkupinaFunkciOpravneni extends GContentBase<SeznamSkupinaFunkciOpravneniObj> {
        private seznamObj: SeznamSkupinaFunkciOpravneniObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamSkupinaFunkciOpravneniObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamSkupinaFunkciOpravneniNew",
                contentCaption: "jres:33000886", //RC 33000886 : Skupiny funkc�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_sfu} - {ixs_fun}"
                },
                gridSettings: {
                    columnOrder: this.getColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private getColumnOrder(): string {
            let columnOrder = "";
            if (this.ixs_sfu)
                columnOrder += "ixs_fun_txt,"
            else if (this.ixs_fun)
                columnOrder += "ixs_sfu_txt,"
            else {
                columnOrder += "ixs_sfu_txt,ixs_fun_txt,"
            }
            columnOrder += "typ_prist_sfu_txt,dat_zmena,zmenu_prov_txt";
            return columnOrder;
        }
    }

    export class SeznamSkupinaFunkciOpravneniObj extends GAdmSeznamBase {
        ixs_sfu: string;
        ixs_fun: string;

        private openFromFunkcniMisto() {
            return this.ixs_fun ? true : false
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailSkupinaFunkciOpravneni", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openFromFunkcniMisto: this.openFromFunkcniMisto(),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailSkupinaFunkciOpravneni",
                newRecord: isNew,
                ixs_sfu: isNew == true ? (this.ixs_sfu ? this.ixs_sfu : null) : data.ixs_sfu,
                ixs_fun: isNew == true ? (this.ixs_fun ? this.ixs_fun : null) : data.ixs_fun,
                typ_prist_sfu: isNew == true ? null : data.typ_prist_sfu
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000888").addField("gselectbox", Gordic.Prefabs.Select.ginssfu(), { //RC 33000888 : Skupina funkc�
                name: "ixs_sfu",
                model: "model.ixs_sfu=value.ixs_sfu",
                dropdown: true,
                disabled: (this.ixs_sfu) ? true : false
            }).addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: true,
                disabled: (this.ixs_fun) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_sfu)
                hardFilter["ixs_sfu"] = this.ixs_sfu;
            if (this.ixs_fun)
                hardFilter["ixs_fun"] = this.ixs_fun;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_sfu)
                data["ixs_sfu"] = this.ixs_sfu;
            if (this.ixs_fun)
                data["ixs_fun"] = this.ixs_fun;
        }

        applydata(filterData: any) {
            this.cnt.isl.SkupinaFunkciOpravneni.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_fun}#${data.ixs_sfu}#${data.typ_prist_sfu}#`,
                nazev: `${data.ixs_fun_txt} - ${data.ixs_sfu_txt} - ${data.typ_prist_sfu_txt}`
            }
        }
    }
}
